// Formatting helpers — deterministic, no Intl dependency.

const MONTHS_PL = [
  'Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec',
  'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień',
];

/** 124000 (grosze) -> "1 240 zł"; 4550 -> "45,50 zł" */
export function formatPln(amountGr: number): string {
  const negative = amountGr < 0;
  const abs = Math.abs(amountGr);
  const zl = Math.floor(abs / 100);
  const gr = abs % 100;
  const zlStr = zl.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const grStr = gr === 0 ? '' : `,${gr.toString().padStart(2, '0')}`;
  return `${negative ? '−' : ''}${zlStr}${grStr} zł`;
}

/** "2026-07-15" -> days from today (local midnight); negative = past */
export function daysUntil(dateIso: string): number {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const [y, m, d] = dateIso.split('-').map(Number);
  const target = new Date(y, m - 1, d);
  return Math.round((target.getTime() - today.getTime()) / 86_400_000);
}

/** "2026-07-15" -> "15.07.2026" */
export function formatDate(dateIso: string): string {
  const [y, m, d] = dateIso.split('-');
  return `${d}.${m}.${y}`;
}

export function currentMonthNamePl(date = new Date()): string {
  return MONTHS_PL[date.getMonth()];
}

export function daysInMonth(date = new Date()): number {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
}

/** local date as ISO yyyy-mm-dd */
export function todayIso(date = new Date()): string {
  const m = (date.getMonth() + 1).toString().padStart(2, '0');
  const d = date.getDate().toString().padStart(2, '0');
  return `${date.getFullYear()}-${m}-${d}`;
}

/** "2026-07-10T14:20:00Z" -> "Dzisiaj, 14:20" / "Wczoraj, 18:05" / "05.07, 12:30" */
export function formatWhenPl(createdAtIso: string, now = new Date()): string {
  const d = new Date(createdAtIso);
  const hm = `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
  const today = new Date(now);
  today.setHours(0, 0, 0, 0);
  const that = new Date(d);
  that.setHours(0, 0, 0, 0);
  const diffDays = Math.round((today.getTime() - that.getTime()) / 86_400_000);
  if (diffDays === 0) return `Dzisiaj, ${hm}`;
  if (diffDays === 1) return `Wczoraj, ${hm}`;
  const dm = `${d.getDate().toString().padStart(2, '0')}.${(d.getMonth() + 1).toString().padStart(2, '0')}`;
  return `${dm}, ${hm}`;
}

/** relative Polish time-ago: "przed chwilą" / "3h temu" / "wczoraj" / "5 dni temu" */
export function timeAgoPl(iso: string, now = new Date()): string {
  const then = new Date(iso).getTime();
  const mins = Math.max(0, Math.round((now.getTime() - then) / 60_000));
  if (mins < 5) return 'przed chwilą';
  if (mins < 60) return `${mins} min temu`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h temu`;
  const days = Math.round(hours / 24);
  if (days === 1) return 'wczoraj';
  return `${days} dni temu`;
}

/** Simple RFC4122-ish v4 UUID (Math.random-based is fine for local mock ids) */
export function uuid(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
